import request from './cache/requestCache';
import proxy from './requestProxy';
import appConfig from '../../../config';

const videoApiConfig = appConfig.videoApi;

const DEFAULT_CONFIGURATION = {
    serviceUrl: 'http://api-app.espn.com/v1/video',
    internalServiceUrl: 'http://sports-bc.prod.espninfra.starwave.com/allsports/apis/v1/video',
    apiKey: ''
};

const config = { ...DEFAULT_CONFIGURATION, ...videoApiConfig };

export function getChannels() {
    const url = `${config.serviceUrl}/channels`;

    return request(url)
        .use(proxy)
        .then((response) => response.body, () => {
            throw new Error('Could not retrieve video api data.');
        });
}



// WEBPACK FOOTER //
// ./app/lib/api/VideoAPI.js